export const ROLES = [
  { value: 'driver', label: 'Driver', badge: 'badge-role-driver', short: 'Driver' },
  { value: 'noc', label: 'NOC', badge: 'badge-role-noc', short: 'NOC' },
  { value: 'field_technician', label: 'Field Technician', badge: 'badge-role-field-technician', short: 'Field Tech' },
  { value: 'customer_care', label: 'Customer Care', badge: 'badge-role-customer-care', short: 'Support' },
  { value: 'finance', label: 'Finance', badge: 'badge-role-finance', short: 'Finance' },
  { value: 'admin', label: 'Admin', badge: 'badge-role-admin', short: 'Admin' },
];

export const CAPABILITIES = [
  { value: 'charging_reservation', label: 'Charging & Reservation' },
  { value: 'live_telemetry_alarms', label: 'Live Telemetry & Alarms' },
  { value: 'remote_ocpp_commands', label: 'Remote OCPP Commands' },
  { value: 'hardware_work_orders', label: 'Hardware Work Orders' },
  { value: 'billing_disputes', label: 'Billing Disputes & Adjustments' },
  { value: 'ledger_settlements', label: 'Ledger & Financial Settlements' },
  { value: 'tariff_schedules', label: 'Tariff Schedules & Models' },
];

export const roleMeta = (value) =>
  ROLES.find((r) => r.value === value) || { value, label: value, badge: 'bg-secondary', short: value };
